import { render, staticRenderFns } from "./FilterBadgeContainer.vue?vue&type=template&id=182f51cc&"
import script from "./FilterBadgeContainer.vue?vue&type=script&lang=js&"
export * from "./FilterBadgeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports